<template>
  <v-card min-height="400">
    <v-card-title class="py-2">
      <v-icon
        class="grey--text mr-3"
        v-text="$getIcon('mdiFileDocumentEdit')"
      ></v-icon>
      <div>
        <div class="body-1" v-text="'Contact Persons'"></div>
        <div
          class="font-1 grey--text caption"
          v-text="
            'Refer to the following information on client\'s contact persons'
          "
        ></div>
      </div>
      <v-spacer></v-spacer>
      <v-btn
        class="indigo accent-2 white--text text-capitalize my-0"
        small
        @click="(contactPersonForm = true) && (selectedContactPersonData = {})"
      >
        Create Contact Person
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-row v-if="!fetched">
        <v-col md="12">
          <vue-default-svg-loader></vue-default-svg-loader>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col md="12">
          <vue-pagination-component
            :fetch-api.sync="fetchAPI"
            :search-label="searchLabel"
            :query-params.sync="queryParams"
            :filter-query="queryParams"
            :next-link="nextLink"
            :previous-link="previousLink"
            :pagination-info="paginationInfo"
          ></vue-pagination-component>
        </v-col>
        <v-col v-if="fetchedData.length < 1 && filtered" md="12">
          Search results not found.
        </v-col>
        <v-col v-else-if="fetchedData.length < 1" md="12">
          <vue-no-data></vue-no-data>
        </v-col>
        <v-row v-else>
          <v-col md="4">
            <v-data-table
              :items="fetchedData"
              class="elevation-1"
              hide-default-footer
              hide-default-header
            >
              <template slot="item" slot-scope="props">
                <tr>
                  <td
                    :style="
                      props.item === selectedContactPerson
                        ? `background: #efefef;`
                        : ``
                    "
                    class="px-1 pointer"
                    @click="selectedContactPerson = props.item"
                  >
                    <div class="d-inline-flex pa-2">
                      <div class="text-right mr-2">
                        <v-avatar tile>
                          <img
                            :src="
                              props.item.image
                                ? props.item.image
                                : `https://core.realhrsoft.com/static/images/default/male.png`
                            "
                          />
                        </v-avatar>
                      </div>
                      <div class="text-left">
                        <div>
                          <a class="link blue--text font-weight-bold">
                            {{ props.item.name }}
                          </a>
                        </div>
                        <div>{{ props.item.primary_email }}</div>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
          <v-col md="8">
            <div v-if="Object.keys(selectedContactPerson).length > 0">
              <div class="text-right">
                <a
                  class="font-0 red--text cursor-pointer"
                  @click="
                    (selectedContactPersonData = selectedContactPerson) &&
                      (deleteDialogue = true)
                  "
                  >Delete</a
                >
                <span class="font-0"> | </span>
                <a
                  class="font-0 grey--text cursor-pointer"
                  @click="
                    (selectedContactPersonData = selectedContactPerson) &&
                      (contactPersonForm = true)
                  "
                  >Update</a
                >
                <span class="font-0"> | </span>
                <a
                  class="font-0 grey--text cursor-pointer"
                  @click="
                    (contactPersonContactNumberForm = true) &&
                      (selectedContactPersonData = selectedContactPerson)
                  "
                  >Add New Phone Number</a
                >
                <span class="font-0"> | </span>
                <a
                  class="font-0 grey--text cursor-pointer"
                  @click="
                    (contactPersonSocialLinkForm = true) &&
                      (selectedContactPersonData = selectedContactPerson)
                  "
                  >Add Social Link</a
                >
              </div>
              <v-card dark>
                <v-card-text>
                  <v-row class="text-left">
                    <v-col md="6">
                      <div class="d-inline-flex">
                        <div class="text-right">
                          <v-avatar tile size="60" class="mr-2">
                            <img
                              :src="
                                selectedContactPerson.image
                                  ? selectedContactPerson.image
                                  : `https://core.realhrsoft.com/static/images/default/male.png`
                              "
                            />
                          </v-avatar>
                        </div>
                        <div class="text-left">
                          <h4 class="font-6">
                            {{ selectedContactPerson.name }}
                          </h4>
                          <h5 v-if="selectedContactPerson.designation">
                            {{ selectedContactPerson.designation.name }}
                          </h5>
                        </div>
                      </div>
                      <div class="grey--text my-2">
                        Social Links
                      </div>
                      <div v-if="selectedContactPerson.social_links.length > 0">
                        <div
                          v-for="(socialLink,
                          index) in selectedContactPerson.social_links"
                          :key="index"
                          class="mt-2"
                        >
                          <v-hover>
                            <div slot-scope="{ hover }">
                              <a
                                :href="socialLink.link"
                                target="_blank"
                                class="blue--text text--darken-3"
                              >
                                {{ socialLink.link }}
                              </a>
                              <v-icon
                                v-if="hover"
                                size="15"
                                class="pointer ml-2"
                                @click="
                                  (selectedContactPersonSocialLinkData = socialLink) &&
                                    (contactPersonSocialLinkForm = true)
                                "
                                v-text="$getIcon('mdiPencil')"
                              >
                              </v-icon>
                            </div>
                          </v-hover>
                        </div>
                      </div>
                      <div v-else>
                        Not found.
                      </div>
                      <div class="my-2">
                        <span class="grey--text">Secondary Email: </span
                        >{{ selectedContactPerson.secondary_email || `N/A` }}
                      </div>
                    </v-col>
                    <v-col md="6">
                      <div class="text-right">
                        <div class="grey--text">
                          Address:
                        </div>
                        <div>
                          {{ selectedContactPerson.address }}
                        </div>
                        <div class="grey--text my-2">
                          Phone Numbers:
                        </div>
                        <div
                          v-if="selectedContactPerson.phone_numbers.length > 0"
                        >
                          <div
                            v-for="(number,
                            index) in selectedContactPerson.phone_numbers"
                            :key="index"
                            class="my-2"
                          >
                            <v-hover>
                              <div slot-scope="{ hover }">
                                <v-icon
                                  v-if="hover"
                                  size="15"
                                  class="pointer"
                                  @click="
                                    (selectedContactPersonNumberData = number) &&
                                      (contactPersonContactNumberForm = true)
                                  "
                                  v-text="$getIcon('mdiPencil')"
                                >
                                </v-icon>
                                {{ number.number }} ({{ number.number_type }})
                              </div>
                            </v-hover>
                          </div>
                        </div>
                        <div v-else>
                          Not found.
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-text>
                  <div class="text-center">
                    {{ selectedContactPerson.primary_email }}
                  </div>
                </v-card-text>
              </v-card>
            </div>
            <div v-else>
              <vue-no-data
                :text="`Please select contact person to view their details.`"
              ></vue-no-data>
            </div>
          </v-col>
        </v-row>
      </v-row>
    </v-card-text>
    <div>
      <!-- Contact Person Form -->
      <v-bottom-sheet v-model="contactPersonForm" scrollable>
        <v-card tile>
          <vue-card-title
            :display-card.sync="contactPersonForm"
            :title="cardTitle"
            :subtitle="
              'Fill up the following form to action on contact person.'
            "
            :icon="$getIcon('mdiFileDocumentEdit')"
            closable
            @close="contactPersonForm = false"
          >
          </vue-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <contact-person-form
              v-if="selectedContactPersonData && contactPersonForm"
              :action-data="selectedContactPersonData"
              @contactPersonFormResponse="formSuccess"
              :client="clientDetail"
            >
            </contact-person-form>
          </v-card-text>
        </v-card>
      </v-bottom-sheet>
      <!-- / Contact Person Form -->
    </div>
    <div>
      <!-- Contact Person Contact Number Form -->
      <v-bottom-sheet v-model="contactPersonContactNumberForm" scrollable>
        <v-card tile>
          <vue-card-title
            :display-card.sync="contactPersonContactNumberForm"
            :title="cardTitle"
            :subtitle="
              'Fill up the following form to action on contact person contact number.'
            "
            :icon="$getIcon('mdiFileDocumentEdit')"
            closable
            @close="contactPersonContactNumberForm = false"
          >
          </vue-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <contact-person-contact-number-form
              v-if="
                selectedContactPersonNumberData &&
                  contactPersonContactNumberForm
              "
              :action-data="selectedContactPersonNumberData"
              :contact-person-data="selectedContactPersonData"
              @contactPersonPhoneNumberFormResponse="formSuccess"
            >
            </contact-person-contact-number-form>
          </v-card-text>
        </v-card>
      </v-bottom-sheet>
      <!-- / Contact Person Contact Number Form -->
    </div>
    <div>
      <!-- Contact Person Social Link Form -->
      <v-bottom-sheet v-model="contactPersonSocialLinkForm" scrollable>
        <v-card tile>
          <vue-card-title
            :display-card.sync="contactPersonSocialLinkForm"
            :title="cardTitle"
            :subtitle="
              'Fill up the following form to action on contact person social link.'
            "
            :icon="$getIcon('mdiFileDocumentEdit')"
            closable
            @close="contactPersonSocialLinkForm = false"
          >
          </vue-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <contact-person-social-link-form
              v-if="
                selectedContactPersonSocialLinkData &&
                  contactPersonSocialLinkForm
              "
              :action-data="selectedContactPersonSocialLinkData"
              :contact-person-data="selectedContactPersonData"
              @contactPersonSocialLinkFormResponse="formSuccess"
            >
            </contact-person-social-link-form>
          </v-card-text>
        </v-card>
      </v-bottom-sheet>
      <!-- / Contact Person Social Link Form -->

      <!-- Client Contact Person Delete -->
      <vue-delete-dialogue
        :open-dialogue.sync="deleteDialogue"
        card-header-info="Confirm Client Contact Person delete"
        :card-text-info="
          `Are you sure you want to delete this Contact Person ` +
            this.selectedContactPersonData.name +
            `?`
        "
        @confirm-delete="deleteContactPerson()"
      ></vue-delete-dialogue>
      <!-- / Client Contact Person Delete -->
    </div>
  </v-card>
</template>
<script>
import PaginationMixin from "@/mixins/paginationSearchMixin";
import ContactPersonForm from "@/components/crm/client/forms/ContactPersonForm";
import ContactPersonContactNumberForm from "@/components/crm/client/forms/ContactPersonContactNumberForm";
import ContactPersonSocialLinkForm from "@/components/crm/client/forms/ContactPersonSocialLinkForm";

export default {
  components: {
    ContactPersonForm,
    ContactPersonContactNumberForm,
    ContactPersonSocialLinkForm
  },
  mixins: [PaginationMixin],
  props: {
    clientDetail: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      // paginationMixin
      fetchAPI:
        "/api/v1/crm/client-contact-person/" +
        "?client__slug=" +
        this.clientDetail.slug,
      searchLabel: "Search for contact persons",
      // form
      cardTitle: "",
      contactPersonForm: false,
      selectedContactPerson: {},
      selectedContactPersonData: {},
      // form contact person number
      contactPersonContactNumberForm: false,
      selectedContactPersonNumberData: {},
      // form contact person social link
      contactPersonSocialLinkForm: false,
      selectedContactPersonSocialLinkData: {},

      deleteDialogue: false
    };
  },
  watch: {
    contactPersonForm(newVal) {
      if (Object.keys(this.selectedContactPersonData).length > 0 && newVal) {
        this.cardTitle = "Update Contact Person";
      } else {
        this.selectedContactPersonData = {};
        this.cardTitle = "Create Contact Person";
      }
    },
    contactPersonContactNumberForm(newVal) {
      if (
        Object.keys(this.selectedContactPersonNumberData).length > 0 &&
        newVal
      ) {
        this.cardTitle = "Update Contact Person Contact Number";
      } else {
        this.selectedContactPersonNumberData = {};
        this.cardTitle = "Create Contact Person Contact Number";
      }
    },
    contactPersonSocialLinkForm(newVal) {
      if (
        Object.keys(this.selectedContactPersonSocialLinkData).length > 0 &&
        newVal
      ) {
        this.cardTitle = "Update Contact Person Social Link";
      } else {
        this.selectedContactPersonSocialLinkData = {};
        this.cardTitle = "Create Contact Person Social Link";
      }
    },
    clientDetail: {
      handler(newVal) {
        this.clientDetail = newVal;
        this.fetchData();
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    formSuccess() {
      this.contactPersonForm = false;
      this.contactPersonContactNumberForm = false;
      this.contactPersonSocialLinkForm = false;
      this.selectedContactPerson = {};
      this.fetchData();
    },
    deleteContactPerson() {
      const contactPersonDeleteAPI = `/api/v1/crm/client-contact-person/${this.selectedContactPerson.id}/deactivate/`;
      this.$axios.$patch(contactPersonDeleteAPI, {}).then(() => {
        const index = this.fetchedData.indexOf(
          this.selectedContactPersonNumberData
        );
        this.fetchedData.splice(index, 1);
        this.deleteDialogue = false;
        this.selectedContactPersonData = {};
        this.$store.dispatch("shell/showSnackbar", {
          text: `Successfully deleted Contact Person`,
          color: "green"
        });
      });
    }
  }
};
</script>
